// 即时销量
import request from '@/services/request'
import api from '@/services/api'

const state = {
  lastTaskStatus: -1, // 最后一次订单匹配关系状态
}

const mutations = {
  SET_LAST_TASK_STATUS: (state, data) => {
    state.lastTaskStatus = data
  },
}

const actions = {
  async getLastTaskStatus({ state, commit }) {
    const { code, data } = await request(api.immediateSales.getLastTaskStatus)
    if (code === 200) {
      commit('SET_LAST_TASK_STATUS', data)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
